// extracted by mini-css-extract-plugin
export default {"root":"LanguageSelector_root__5Mn5s","option":"LanguageSelector_option__On1qM"};